import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

type ZubieClaims = {
  redirect_url: string;
  token: string;
};

export const loadZubieUrl = (token?: string) => {
  return apiRequest<ZubieClaims>(
    {
      url: `${getCoreApi()}/users/zubie/claims`,
      method: 'GET',
    },
    true,
    false,
    token,
  );
};
